import { render, staticRenderFns } from "./ContentSkeleton.vue?vue&type=template&id=128e561c&scoped=true"
import script from "./ContentSkeleton.vue?vue&type=script&lang=ts"
export * from "./ContentSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ContentSkeleton.vue?vue&type=style&index=0&id=128e561c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e561c",
  null
  
)

export default component.exports